'use client';

import { GetWrapupType, WrapupModuleKillsData } from "@/src/server/models/seasonal/wrapup/modules/getwrapup";
import IWrapupModule from "./imodule";
import WrapupModuleKillsContinuedComponent from "./killscontdcomponent";

export default class WrapupModuleKillsContinued implements IWrapupModule {
    constructor() { }

    get id(): string { return 'killscontd'; }
    get name(): string { return 'Kills Cont.'; }

    canRender(wrapupData: GetWrapupType): boolean {
        const killsData = wrapupData?.data?.kills as WrapupModuleKillsData;
        return killsData?.killedByUserIds?.length > 0;
    }

    getComponentClass() {
        return WrapupModuleKillsContinuedComponent;
    }
}
